import React, {useEffect, useState} from "react";
import {useQueryClient} from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import "../../App.css";
import __ from "lodash";

import { makeStyles } from "@material-ui/core/styles";
import { Toolbar, Tooltip } from "@material-ui/core";

import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import ChromeTabs from "../../controls/ChromeTabs";

import CateringOrderStyles from "./styles/CateringOrderStyles";
import IconButton from "@material-ui/core/IconButton";
import { FastForward, FastRewind } from "@material-ui/icons";
import { getDateTabs } from "../../functions/DateTabs";
import CateringOrdersList from "./components/CateringOrdersList";
import FlightsMissingCateringOrdersList from "./components/FlightsMissingCateringOrdersList";
import useCountCateringOrders from "../../services/flights/useCountCateringOrders";
import CateringOrdersToReviewList from "./components/CateringOrdersToReviewList";


const AccessControl = require("../../AccessControl");

function CateringOrders(props) {
  const classes = makeStyles(CateringOrderStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, [
    "Super Admin",
    "Admin",
    "Manage TRIPS",
    "Manage CATERING ORDERS"
  ]);

  const queryClient = useQueryClient();

  let missingOrderCount = useCountCateringOrders({queryClient, extraKeys: ['MISSING']});
  let ordersToReviewCount = useCountCateringOrders({queryClient, extraKeys: ['REVIEW']});

  const [listTabs, setListTabs] = useState([
    { label: `Catering Orders to Review`, value: "review", badge: {content: 0}},
    { label: "Flights Missing Catering Orders", value: "requirements", badge: {content: 0} },
    { label: "Outstanding", value: "outstanding" },
  ]);

  useEffect(()=> {
    const tabs = [...listTabs];
    let tabsChanged = false;
    if (missingOrderCount && missingOrderCount.status === 'success' && missingOrderCount.data !== undefined) {
      const tab = __.find(listTabs, {value: "requirements"});
      if (tab && tab.badge?.content !== missingOrderCount.data) {
        tab.badge = {content: missingOrderCount.data};
        tabsChanged = true;
      }
    }
    if (ordersToReviewCount && ordersToReviewCount.status === 'success' && ordersToReviewCount.data !== undefined ) {
      const tab = __.find(listTabs, {value: "review"});
      if (tab&& tab.badge?.content !== ordersToReviewCount.data) {
        tab.badge = {content: ordersToReviewCount.data};
        tabsChanged = true;
      }
    }
    if (tabsChanged && Array.isArray(listTabs)) setListTabs(tabs);
  },[listTabs, missingOrderCount, missingOrderCount.data, ordersToReviewCount, ordersToReviewCount.data]);

  const [dateTabs, setDateTabs] = useState(
    getDateTabs(undefined, undefined, 1, 4)
  );

  const [state, setState] = useState({
    monthTabIndex: canEdit ? "outstanding" : 5,
  });

  const handleChangeMonth = (e, i) => {
    const change = { monthTabIndex: i };
    handleChange(change);
  };

  const handleChange = (change) => {
    const { month, year } =
      change.monthTabIndex === "review" ||
      change.monthTabIndex === "outstanding" ||
      change.monthTabIndex === "requirements"
        ? { month: 0, year: 0 }
        : dateTabs.values[change.monthTabIndex];
    const newState = { ...change, month, year };
    if (newState) {
      setState({
        ...state,
        ...newState,
      });
    }
  };

  const handleTabSetChange = (index) => {
    setDateTabs(getDateTabs(dateTabs, index, 5, 0));
  };

  const handleTabChange = (e, tab) => {
    setState({ monthTabIndex: tab });
  };

  const currentTab = (state.monthTabIndex = state.monthTabIndex || 0);
  const { month, year } =
    state.monthTabIndex === "review" ||
    state.monthTabIndex === "outstanding" ||
    state.monthTabIndex === "requirements"
      ? { month: 0, year: 0 }
      : dateTabs.values[state.monthTabIndex];

  return (
    isAuthenticated && (
      <div
        className="FuelOrders"
        style={{
          backgroundColor: "#eeeeee",
          color: "#1b4481",
          fontWeight: 400,
          fontFamily: "Ubuntu,sans-serif",
          minHeight: "100vh",
        }}
      >
        <PageHeader
          parentProps={props}
          activeMenuItem="cateringorders"
          pageName="Catering Orders"
          loggedInUser={user}
          logout={""}
        ></PageHeader>
        <div
          style={{
            marginLeft: 40,
            marginRight: 40,
            height: 2,
            backgroundColor: "#b7c3d4",
          }}
        ></div>
        <div style={{ height: 10 }}></div>

        <div
          className={classes.rooted}
          style={{ marginLeft: 20, marginRight: 20 }}
        >
          {canEdit ? (
            <Toolbar>
              <ChromeTabs
                id={"CateringOrders"}
                style={{ alignSelf: "flex-end" }}
                tabs={listTabs}
                tabStyle={{
                  bgColor: "#E6E8EB",
                  selectedBgColor: "#ffffff",
                  color: "rgba(0,0,0,0.87)",
                }}
                tabProps={{
                  disableRipple: false,
                }}
                value={currentTab}
                onChange={handleTabChange}
              />
            </Toolbar>
          ) : (
            <></>
          )}
          <Toolbar>
            <div
              style={{
                width: "50px",
                marginRight: 10,
                marginLeft: 10,
                height: 45,
              }}
            >
              <IconButton
                color="primary"
                onClick={() => {
                  handleTabSetChange(-1);
                }}
              >
                <FastRewind fontSize="large" />
              </IconButton>
            </div>
            <ChromeTabs
              id={"Months"}
              style={{ alignSelf: "flex-end" }}
              tabs={dateTabs.tabs}
              tabStyle={{
                bgColor: "#E6E8EB",
                selectedBgColor: "#ffffff",
                color: "rgba(0,0,0,0.87)",
              }}
              tabProps={{
                disableRipple: false,
              }}
              value={currentTab}
              onChange={handleChangeMonth}
            />
            <div
              style={{
                width: "50px",
                marginRight: 10,
                marginLeft: 10,
                height: 45,
              }}
            >
              <IconButton
                color="primary"
                onClick={() => {
                  handleTabSetChange(1);
                }}
              >
                <FastForward fontSize="large" />
              </IconButton>
            </div>
          </Toolbar>
        </div>
        <div
          className={classes.rooted}
          style={{
            marginLeft: 20,
            marginRight: 20,
            minHeight: `calc(100vh - ${99 + 2 + 10 + 57 + 64 + 4}px)`,
          }}
        >
          {currentTab === "requirements" ? (
            <FlightsMissingCateringOrdersList
              classes={classes}
              canEdit={canEdit}
              month={month}
              year={year}
              required={true}
            />
            ):currentTab === "review" ? (
              <CateringOrdersToReviewList
                classes={classes}
                canEdit={canEdit}
                month={month}
                year={year}
                required={"review"}
              />
            ) : currentTab !== "outstanding" ? (
            <CateringOrdersList
              classes={classes}
              canEdit={canEdit}
              month={month}
              year={year}
            />
          ) : (
            <CateringOrdersList
              classes={classes}
              canEdit={canEdit}
              month={month}
              year={year}
            />
          )}
        </div>

        <PageFooter></PageFooter>
      </div>
    )
  );
}

export default CateringOrders;
